module.exports = __webpack_public_path__ + "static/media/mashable.a292b3f2.jpg";